const recentPostExclusionCopy =
  'Posts from the last 48 hours are excluded because performance is still stabilizing.';

export function getCampaignAnalysisExclusionReasons() {
  return [recentPostExclusionCopy] as const;
}
